import { inject } from "@vercel/analytics";
import React, { PropsWithChildren } from "react";

import {
  SettingsProvider,
  SettingsProviderProps,
} from "shared/SettingsProvider";
import { withApp } from "utils/with-app.utils";

import { Footer } from "./Footer";
import { Navbar } from "./Navbar";

type LayoutProps = {
  withBanner?: boolean;
  settings?: Partial<SettingsProviderProps>;
};

export const Layout = ({
  children,
  withBanner,
  settings,
}: PropsWithChildren<LayoutProps>) => {
  inject();

  return (
    <SettingsProvider isBlackFriday={!!settings?.isBlackFriday}>
      <Navbar withBanner={withBanner} />

      {children}

      <Footer />
    </SettingsProvider>
  );
};

export const AppLayout = withApp(Layout, [], true);
